import Api from '@/services/Api'

export default {
  // Método que llama a la url para crear un chat
 getUsers () {
   return Api().get("/users?page=0&size=10000");
},
  getUsersByCompany (params) {
    return Api().get("/users-by-company/"+params);
  },
  updateUser (params) {
    return Api().put("/users/",params);
  },
  addUser (params) {
    return Api().post("/users/",params);
  },
  getUser (params) {
    return Api().get("/users/"+params);
  },
  deleteUser (params) {
    return Api().delete("/users/"+params);
  },
  getRols () {
    return Api().get('/users/authorities')
  },
  getUsersReport(){
    return Api().get("/reports/user-logs")
  }

}



// WEBPACK FOOTER //
// ./src/services/UserService.js